import { api, API } from "./api";

export async function getDashboard(userId) {
  const { data } = await api.get("/architect-portal/dashboard", {
    params: { user_id: userId },
  });
  return data;
}

export async function getAtAGlance(userId) {
  const { data } = await api.get("/architect-portal/at-a-glance", {
    params: { user_id: userId },
  });
  return data;
}

export async function listInquiries(userId, { status, q } = {}) {
  const params = { user_id: userId };
  if (status && status !== "all") params.status = status;
  if (q) params.q = q;
  const { data } = await api.get("/architect-portal/inquiries", { params });
  return data;
}

export function inquiriesExportUrl(userId) {
  return `${API}/architect-portal/inquiries/export.csv?user_id=${encodeURIComponent(
    userId
  )}`;
}

export async function getConsultation(consultId, userId) {
  const { data } = await api.get(
    `/architect-portal/consultations/${encodeURIComponent(consultId)}`,
    { params: { user_id: userId } }
  );
  return data;
}

export async function postConsultationMessage(consultId, userId, body) {
  const { data } = await api.post(
    `/architect-portal/consultations/${encodeURIComponent(consultId)}/messages`,
    { actor_user_id: userId, body }
  );
  return data;
}

export async function patchChecklist(consultId, userId, key, value, note) {
  const { data } = await api.patch(
    `/architect-portal/consultations/${encodeURIComponent(consultId)}/checklist`,
    { actor_user_id: userId, key, value, note }
  );
  return data;
}

export async function activateConsultation(consultId, userId) {
  const { data } = await api.post(
    `/architect-portal/consultations/${encodeURIComponent(consultId)}/activate`,
    { actor_user_id: userId }
  );
  return data;
}

export async function declineConsultation(consultId, userId, reason) {
  const { data } = await api.post(
    `/architect-portal/consultations/${encodeURIComponent(consultId)}/decline`,
    { actor_user_id: userId, reason }
  );
  return data;
}

export async function getProfile(userId) {
  const { data } = await api.get("/architect-portal/profile", {
    params: { user_id: userId },
  });
  return data;
}

export async function patchProfile(userId, fields) {
  const { data } = await api.patch("/architect-portal/profile", {
    actor_user_id: userId,
    ...fields,
  });
  return data;
}

export async function listMyDesigns(userId) {
  const { data } = await api.get("/architect-portal/designs", {
    params: { user_id: userId },
  });
  return data;
}

export async function requestVerification(userId, fields) {
  const { data } = await api.post(
    "/architect-portal/profile/verification-request",
    { actor_user_id: userId, ...fields },
  );
  return data;
}

export async function countersignContract(projectId, userId, signature) {
  const { data } = await api.post(
    `/architect-portal/projects/${encodeURIComponent(projectId)}/contract/countersign`,
    { actor_user_id: userId, signature },
  );
  return data;
}

export async function rejectContract(projectId, userId, reason) {
  const { data } = await api.post(
    `/architect-portal/projects/${encodeURIComponent(projectId)}/contract/reject`,
    { actor_user_id: userId, reason },
  );
  return data;
}

export async function markSubmittedToCity(projectId, userId) {
  const { data } = await api.post(
    `/architect-portal/projects/${encodeURIComponent(projectId)}/mark-submitted-to-city`,
    { actor_user_id: userId },
  );
  return data;
}


